import {MessageBox} from 'element-ui'

const dialog = ({
                  title = '警告',
                  content = '此操作将无法回退,确认执行该操作?',
                  type = 'confirm',
                  okText = '确认',
                  cancelText = '取消',
                  closable = true,
                  params = {}
                }) => {
  return new Promise((resolve, reject) => {
    if (type === 'confirm') {
      MessageBox.confirm(content, title, {
        okText,
        cancelText,
        closable,
        footerHide: true,
        maskClosable: true,
        beforeClose: (action, instance, done) => {
          if (action == 'confirm') {
            resolve(params)
          } else if (action == 'cancel') {
            reject(params);
          }
          done();
        },
        onCancel: (err) => {
          console.log(err);
          reject(params);
        }
      })
    } else if (type === 'info') {
      MessageBox.info(content, title, {
        title: title,
        message: content,
        beforeClose: (action, instance, done) => {
          resolve(params)
          done();
        },
      })
    }
  })
}

export default dialog;



// WEBPACK FOOTER //
// ./src/cuview-ui/libs/function/dialog.js